import React, { ChangeEvent, FC, useContext } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';
import { StringInputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import BaseTextField from '../baseTextField';
import { CustomFormContext } from '../customFormContextProvider';

const CityField: FC<ValueFieldProps<StringInputViewModel>> = (props) => {
  const customFormContext = useContext(CustomFormContext);
  const [selectedAddress, setSelectedAddress] = customFormContext?.selectedAddress ?? [];

  const inputAttributes = {
    onInput: (event: ChangeEvent<HTMLInputElement>) => {
      if (setSelectedAddress && selectedAddress?.city)
        setSelectedAddress({ ...selectedAddress, city: event.target.value });
    },
  };
  return (
    <BaseTextField
      type="text"
      {...props}
      inputAttributes={inputAttributes}
      value={selectedAddress?.city || props.value}
    />
  );
};

export default CityField;
